import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';

import { toggleDisqusClaim } from './enable-disqus-claim';

import Switch from 'app/scripts/components/common/inputs/customs/switch';

export class EnableClaimDisqus extends Component {
  static defaultProps = {
    value: true
  };

  static propTypes = {
    value: PropTypes.bool.isRequired,
    spotId: PropTypes.string.isRequired
  };

  static displayName = 'EnableClaimDisqus';

  static contextTypes = {
    executeAction: PropTypes.func
  };

  @autobind
  onChange(value) {
    if (value !== this.props.value) {
      this.context.executeAction(toggleDisqusClaim, {
        spotId: this.props.spotId
      });
    }
  }

  render() {
    return (
      <div className="monetization-switch">
        <Switch
          title="Enable Disqus Claim for Site"
          description={
            <span>
              <span>{'Enable this will add the "'}</span>
              <span className="disqus-link"> Have a Disqus Account?</span> {'"'}
            </span>
          }
          value={this.props.value}
          onChange={this.onChange}
        />
      </div>
    );
  }
}
